module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"editorial_brief":"Editorial brief"},"fr":{"editorial_brief":"Brief editorial"},"de":{"editorial_brief":"Kurzredaktion"}}')
  delete Component.options._Ctor
}
